import { render, staticRenderFns } from "./MailAIAssistant.vue?vue&type=template&id=28088d0a&scoped=true"
import script from "./MailAIAssistant.vue?vue&type=script&lang=js"
export * from "./MailAIAssistant.vue?vue&type=script&lang=js"
import style0 from "./MailAIAssistant.vue?vue&type=style&index=0&id=28088d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28088d0a",
  null
  
)

export default component.exports